import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const SVG = styled.svg`
  fill: ${props => props.fill ? props.fill : '#077233'};
  .cls-1 {
    clip-rule: evenodd;
  }
  .cls-3 {
      clip-path: url(#clip-path);
  }
  .cls-4 {
      clip-path: url(#clip-path-2);
  }
`

const Shield = (props) => {
  const { fill } = props
  return (
    <SVG
      viewBox="8 8 158.31 172.63"
      version="1.1"
      id="svg124"
      fill={props.fill}>
      <title>Fantasy Golf Championships</title>
      <defs
        id="defs112">
        <clipPath
          id="clip-path"
          transform="translate(12.2 12.2)">
          <path
            className="cls-1"
            d="M62,138.23a10,10,0,0,1-4.74-1.18L4.66,107.14a9.52,9.52,0,0,1-4.66-8L.07,39.24a9.57,9.57,0,0,1,4.66-8l52.67-30a9.69,9.69,0,0,1,9.26,0l52.6,29.93a9.47,9.47,0,0,1,4.65,8L123.85,99a9.61,9.61,0,0,1-4.66,8Zm54.12-36.62A3.38,3.38,0,0,0,117.63,99l.07-59.83a3.35,3.35,0,0,0-1.51-2.65L63.59,6.58a4.16,4.16,0,0,0-1.65-.37,2.93,2.93,0,0,0-1.46.37l-52.67,30a3.38,3.38,0,0,0-1.53,2.63L6.21,99.12a3.35,3.35,0,0,0,1.52,2.61l52.6,29.92a3.42,3.42,0,0,0,3.09,0Z"
            id="path106" />
        </clipPath>
        <clipPath
          id="clip-path-2"
          transform="translate(12.2 12.2)">
          <rect
            className="cls-2"
            x="-178.38"
            y="-1424.8"
            width="839.27"
            height="1678.53"
            id="rect109" />
        </clipPath>
      </defs>
      <g
        id="Layer_2"
        data-name="Layer 2"
        transform="matrix(1.1441282,0,0,1.1441282,0,-0.00897875)">
        <g
          id="Layer_1-2"
          data-name="Layer 1">
          <g
            className="cls-3"
            clipPath="url(#clip-path)"
            id="g118">
            <g
              className="cls-4"
              clipPath="url(#clip-path-2)"
              id="g116">
              <rect
                className="cls-5"
                width="148.31"
                height="162.63"
                id="rect114"
                x="0"
                y="0" />
            </g>
          </g>
          <path
            className="cls-5"
            d="m 98.6,99 c -0.29,-0.4 -0.82,-2.71 -1.19,-3.11 -0.37,-0.4 -0.14,-1.13 -0.41,-1.58 -1.42,-2.33 0.33,-5 -1.13,-7.44 -4.36,-7.15 -5,-15.9 -10.38,-23.08 3.29,-1.1 6,-2.21 8.74,-2.88 2.74,-0.67 3.61,-2.23 3.38,-5.08 -0.46,-5.8 -4.14,-10 -6.72,-14.76 C 89.66,38.8 87.27,37 88,34 80.76,30.94 75.59,36 69.34,39.1 71.52,35.24 71.17,34.56 67.67,34.18 A 23.58,23.58 0 0 1 65,33.82 c -7.53,-1.75 -12,1.92 -11.79,9.87 l -2.45,0.82 c -6.7,2.22 -13.54,3.93 -20.25,6.11 a 65,65 0 0 0 -7.79,2.32 c -3.65,1.11 -4.27,4 -4.25,7.21 0,2.08 1.24,2.59 3.05,2.34 1.81,-0.25 2.09,-1.26 1.66,-3 -0.43,-1.74 -1.34,-3.08 -0.87,-4.93 2.55,-1.66 5.65,-2 8.45,-3.11 7,-1.81 13.9,-4 20.87,-6 2.19,-0.62 3.6,-0.21 3.64,2.19 a 3.2,3.2 0 0 0 2.2,3 C 61,52 61,55.17 60,57.21 a 12.81,12.81 0 0 0 0.6,12.59 c 4.06,7 9.83,12.81 9.41,21.56 a 3.26,3.26 0 0 0 0.79,2.12 c 1.5,1.65 1.48,3.2 0.38,5.08 a 9.37,9.37 0 0 0 -1.39,4.08 c -0.1,2.61 0.89,10.54 0.81,13.16 14,-7.47 18.67,-9.33 28,-16.8 z m -27,-53.89 c -0.22,-1.42 -0.66,-2.81 -1.12,-4.72 2.35,-0.5 4.55,-2.12 6.48,0.76 0.36,0.53 1.35,0.73 2.1,0.89 2.05,0.45 3.4,1.21 3.21,3.76 -0.16,2.34 -0.93,3.54 -3.34,4.18 -6.3,1.69 -6.25,1.81 -7.29,-4.87 z"
            transform="translate(12.2,12.2)"
            id="path120" />
        </g>
      </g>
    </SVG>
  )
}
Shield.propTypes = {
  fill: PropTypes.string,
}

export default Shield



// WEBPACK FOOTER //
// ./src/images/icons/shubgolf/Shield.js